/** ******************************************************* {COPYRIGHT-TOP} ***
 * Licensed Materials - Property of IBM
 *
 * (C) Copyright IBM Corporation 2016, 2025
 *
 * All Rights Reserved.
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 ********************************************************** {COPYRIGHT-END} * */

import React from 'react';
import { Select, SelectItem } from '@carbon/react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { useApi } from '../contexts/ApiHandler';

function EndpointSelector({
  endpoints,
  opPath,
  id,
  endpoint,
  onChange = () => {
    console.warn('EndpointSelector onChange not set');
  }
}) {
  const { t } = useTranslation();
  const { apiHandler } = useApi();

  let operationEndpoints;

  if (endpoints && endpoints.length > 1) {
    operationEndpoints = (
      <Select data-testid={id} onChange={onChange} id={id} value={endpoint || endpoints[0].url} hideLabel>
        {endpoints.map((param) => {
          const paramTypesText = param.types ? `${param.types}: ` : '';
          // eslint-disable-next-line no-unsafe-optional-chaining
          return <SelectItem key={param.url} value={param.url} text={paramTypesText + apiHandler?.buildFullUrl(param.url, opPath)} />;
        })}
      </Select>
    );
  } else if (endpoints && endpoints.length === 1 && endpoints[0].url) {
    const endpointTypesText = endpoints[0].types ? `${endpoints[0].types}: ` : '';
    operationEndpoints = (
      <div className="apiEndpoint" key={endpoints[0].url}>
        {endpointTypesText && <div className="apiEndpointType">{endpointTypesText}</div>}
        <div className="apiEndpointUrl">{apiHandler?.buildFullUrl(endpoints[0].url, opPath)}</div>
      </div>
    );
  } else {
    operationEndpoints = <div>{t('no_endpoint')}</div>;
  }

  return <div className="endpointDisplay">{operationEndpoints}</div>;
}

EndpointSelector.propTypes = {
  endpoints: PropTypes.array,
  opPath: PropTypes.string,
  onChange: PropTypes.func,
  id: PropTypes.string
};

export default EndpointSelector;
